// utils/dataValidation.js
export const validateCorporationData = (data) => {
  if (!data || typeof data !== 'object') {
    throw new Error('Invalid corporation data format');
  }

  // Whitelist allowed properties
  const allowedKeys = ['value', 'label', 'id', 'name'];
  const validated = {};
  
  for (const key of allowedKeys) {
    if (key in data) {
      // Ensure values are strings and sanitize
      if (typeof data[key] === 'string') {
        validated[key] = data[key].trim();
        
        // Prevent script injection
        if (validated[key].includes('<') || validated[key].includes('>')) {
          throw new Error('Invalid characters detected');
        }
      } else if (typeof data[key] === 'number') {
        validated[key] = data[key];
      }
    }
  }

  if (!validated.value) {
    throw new Error('Missing required field: value');
  }

  return validated;
};

export const validateSessionStorage = (key, schema) => {
  try {
    const data = sessionStorage.getItem(key);
    if (!data) return null;
    
    const parsed = JSON.parse(data);
    
    // Validate against schema
    if (schema && typeof schema === 'function') {
      return schema(parsed);
    }
    
    return parsed;
  } catch (error) {
    console.error(`Failed to validate ${key}:`, error);
    return null;
  }
};